var scrollTopInit;

(function ($) {

	const selectors = {
		link: '[data-scroll-top]',
	}

	scrollTopInit = function () {
		$(selectors.link).on('click', (e) => {
			e.preventDefault();
			$('html, body').animate({ 'scrollTop': 0 }, 1000);
		});
	}

})(jQuery);


export default scrollTopInit;